import config from "emun.cart/cart.config";
import views from "emun.cart/multi-cart/multi-cart.views";
import labels from "emun.order/_labels";
// import sortBy from "lodash/sortBy";
import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import _ from "underscore";

let instance = 0;

export default class MultiCartController extends BasicAutoQueryController {
  getQuery() {
    const $ctrl = this;
    $ctrl.labels = labels;
    $ctrl.config = config;
    $ctrl.views = views;
    $ctrl.instance = instance++;
    $ctrl.ngModel = this;
    $ctrl.cartIds = [];
    $ctrl.collapsed = {};
    console.debug("#MultiCartController", $ctrl.instance, $ctrl);
    $ctrl.$load = _.debounce(() => $ctrl.query && $ctrl.query.load(), 488);
    $ctrl.$on("cartRemoved", () =>
      $ctrl.$load(console.warn("cartRemoved", $ctrl.instance, arguments))
    );
    $ctrl.$on("cartReset", () =>
      $ctrl.$load(console.warn("cartReset", $ctrl.instance, arguments))
    );
    $ctrl.$on("cartUpdated", () =>
      $ctrl.$load(console.warn("cartUpdated", $ctrl.instance, arguments))
    );
    $ctrl.$on("cartStatsUpdated", () =>
      $ctrl.$load(console.warn("cartStatsUpdated", $ctrl.instance, arguments))
    );
    const result = {
      url: "QueryCarts.json",
      criteria: {
        multiCartId: $ctrl.multiCartId || $ctrl.$cart.multiCartId,
        StatusIn: $ctrl.orderStatus || "Cart",
        op: "getCartsByMultiId",
        DontIncludeProducts: true,
        OrderBy: "VendorId,Id",
      },
      autoLoad: !!($ctrl.multiCartId || $ctrl.$cart.multiCartId),
      pageSize: 100,
      onLoaded: $ctrl.onLoaded.bind($ctrl),
    };

    if (
      Array.isArray($ctrl.submittedCartIds) &&
      $ctrl.submittedCartIds.length
    ) {
      result.criteria.IdIn = $ctrl.submittedCartIds; //.join(",");
      result.criteria.op = "getCartsByIds";
      delete result.criteria.multiCartId;
    }
    result.criteria.autoLoad =
      !!result.criteria.multiCartId || result.criteria.submittedCartIds;

    return result;
  }

  $onChanges({ multiCartId }) {
    const $ctrl = this;
    console.info("$onChanges", $ctrl.instance, { multiCartId, $ctrl });
    if (
      multiCartId &&
      multiCartId.currentValue &&
      multiCartId.currentValue.length &&
      $ctrl.query &&
      multiCartId.currentValue !== $ctrl.query.criteria.multiCartId
    ) {
      // console.warn("$onChanges", $ctrl.instance, multiCartId.currentValue, {
      //   multiCartId,
      //   $ctrl,
      // });
      $ctrl.query.criteria.multiCartId = multiCartId.currentValue;
      $ctrl.$load();
    }
  }

  select(id) {
    const $ctrl = this;
    $ctrl.$stateParams.cartId = id;
    $ctrl.$cart
      .load(id, null, { validate: false })
      .then(() => $ctrl.setCollapsed());
    // const $loc = $ctrl.$ioc("$location");
    // $loc.search("cartId", id);
    // $loc.replace();
  }

  isVendorFirstOrder(vendorName) {
    const $ctrl = this;
    return $ctrl.query.results.filter(function (r) {
      return r.vendor.vendorName === vendorName && r.vendorFirstOrder;
  }).length > 0;
  }
  setCollapsed() {
    const $ctrl = this;
    $ctrl.collapsed = ($ctrl.cartIds || []).reduce((a, i) => {
      a[i] = i !== ($ctrl.$cart && $ctrl.$cart.id);
      return a;
    }, {});
  }

  onLoaded(args) {
    const $ctrl = this;
    // const sorted = sortBy(args.results, "vendor.vendorName");
    // console.warn("#onLoaded", $ctrl.instance, args);
    const visible = [];
    const agg = args.results.reduce(
      (acc, cart) => {
        acc.cartIds.push(cart.id);
        acc["#" + cart.id] = cart;
        if (cart.grandTotal === 0) {
          return acc;
        }
        if (cart.balance === -1) {
          acc.savedForLater.push(cart);
          return acc;
        }
        if (config.vendorMinimums) {
          acc.promises.push(
            $ctrl.query.bus
              .send("CheckVendorMinimums.json?CartId=" + cart.id)
              .then(({ data }) => {
                if (data.length) {
                  acc.preventCheckout[cart.id] = cart;
                }
                cart.vendorMinimums = data;
                acc.vendorsUnderMinimum += data.length;
              })
          );
        }
        if (config.categoryRestrictions && cart.vendorId in config.categoryRestrictions) {
          acc.promises.push(
            $ctrl.query.bus
              .send(
                "CheckCategoryRestrictionsMin.json?CartId=" +
                  cart.id +
                  "&$VendorId=" +
                  cart.vendorId
              )
              .then(({ data }) => {
                if (data.categoryMinimumViolations.length) {
                  acc.preventCheckout[cart.id] = cart;
                  // acc.categoryMinimumViolationCarts[cart.id] = cart;
                  cart.categoryMinimumViolations =
                    data.categoryMinimumViolations;
                  acc.categoryMinimumViolations +=
                    data.categoryMinimumViolations.length;
                }
              })
          );
        }
        acc.promises.push(
          $ctrl.query.bus
            .send("CheckPromotions.json?CartId=" + cart.id)
            .then(({ data }) => {
              cart.promos = data.results;
              cart.promosOffered = cart.promos.filter(
                (o) => o.qualified
              ).length;
            })
        );
        acc.grandTotal += cart.grandTotal;
        acc.cartCount += 1;
        acc.itemCount += cart.items.length;
        visible.push(cart);
        return acc;
      },
      {
        grandTotal: 0,
        itemCount: 0,
        cartCount: 0,
        vendorsUnderMinimum: 0,
        categoryMinimumViolations: 0,
        preventCheckout: {},
        promises: [],
        categoryRestricted: [],
        unrestrictedIds: [],
        categoryRestrictedIds: [],
        cartIds: [],
        savedForLater: [],
      }
    );

    $ctrl
      .$ioc("$q")
      .all(agg.promises)
      .then(() => {
        const sortedOrders = _.sortBy(visible, (o) => o.vendor.vendorName);
        agg.minimumMet = [];
        agg.belowMinimum = [];
        agg.minimumMetIds = [];
        agg.belowMinimumIds = [];
        agg.minimumMetTotal = 0;
        agg.belowMinimumTotal = 0;
        agg.loaded = new Date();

        // BL/Sy: use this to toggle the category restrictions from showing on the good carts
        const HIDE_CATEGORY_RESTRICTIONS_FROM_GOOD_CARTS = true;

        const predicate = HIDE_CATEGORY_RESTRICTIONS_FROM_GOOD_CARTS
          ? (o) => o.id in agg.preventCheckout
          : (o) => o.vendorMinimums && o.vendorMinimums.length;
        for (let o of sortedOrders) {
          const which = predicate(o);
          agg[which ? "belowMinimum" : "minimumMet"].push(o);
          agg[`${which ? "belowMinimum" : "minimumMet"}Ids`].push(o.id);
          agg[`${which ? "belowMinimum" : "minimumMet"}Total`] += o.grandTotal;
        }
        agg.canCheckoutIds = agg.minimumMetIds.filter(
          (id) => !agg.preventCheckout[id]
        );

        Object.assign($ctrl, agg);
        $ctrl.setCollapsed();
        // console.debug(".all(promises)", $ctrl.instance, agg);
      });
  }
}
